import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";

//库存盘点情况
export default () => {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    )
}